import { Typography } from '@mui/material';

interface InactiveBreadcrumbProps {
  [key: string]: any;
}

export const InactiveBreadcrumb: React.FC<InactiveBreadcrumbProps> = props => {
  return <Typography color="text.primary" fontSize="0.875rem" {...props} />;
};
